import { useContext } from 'react';
import { grantFilterContext } from './GrantFilterProvider';


const rowStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem',
                   padding: '0.5rem 0.5rem', flexWrap: 'nowrap',
                   color: '#fff' };
const inputStyle = { padding: '0.3rem 0.5rem', borderRadius: 8,
                     border: '1px solid #fff', width: '13ch',
                     background: '#0A0A0A', color: '#fff' };

const digitsOnly = (text) => text.replace(/\D/g, '').slice(0, 12);

export function DeadlineControl() {
  const { deadlineAfter, setDeadlineAfter } = useContext(grantFilterContext);
  return (
    <div style={rowStyle}>
      <label>Due on or after</label>
      <input
        type="date"
        style={{ ...inputStyle, width: 'auto', colorScheme: 'dark' }}
        value={deadlineAfter}
        onChange={(e) => setDeadlineAfter(e.target.value)}
      />
      {deadlineAfter && (
        <button type="button" onClick={() => setDeadlineAfter('')}>clear</button>
      )}
    </div>
  );
}

export function AmountControl() {
  const { amountMin, setAmountMin, amountMax, setAmountMax } =
    useContext(grantFilterContext);
  return (
    <div style={rowStyle}>
      <input
        type="text" inputMode="numeric" placeholder="smallest"
        style={inputStyle} maxLength={12}
        value={amountMin}
        onChange={(e) => setAmountMin(digitsOnly(e.target.value))}
      />
      <span>to</span>
      <input
        type="text" inputMode="numeric" placeholder="largest"
        style={inputStyle} maxLength={12}
        value={amountMax}
        onChange={(e) => setAmountMax(digitsOnly(e.target.value))}
      />
      {(amountMin !== '' || amountMax !== '') && (
        <button type="button"
          onClick={() => { setAmountMin(''); setAmountMax(''); }}>clear</button>
      )}
    </div>
  );
}
